module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/242-madagascar-a522eef93d1a1801eb5214893b0cf528.svg";